// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';

import { Route } from 'react-router';
import { IndexRoute } from 'react-router';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import AccountRoot from 'modules/Account/Izenda.AccountRoot';
import Activation from 'modules/Account/Izenda.Activation';
import Login from 'modules/Account/Izenda.Login';
import ResetPasswordWrapper from 'modules/Account/Izenda.ResetPasswordWrapper';
import ForgotPasswordWrapper from 'modules/Account/Izenda.ForgotPasswordWrapper';

const AccountRoutes = () => {
  const ROUTE = routeUtils.getConfigRoute('Account');
  const ACTIVATION_ROUTE = routeUtils.getConfigRoute('Account', 'Activation');
  const LOGIN_ROUTE = routeUtils.getConfigRoute('Account', 'Login');
  const RESET_ROUTE = routeUtils.getConfigRoute('Account', 'ResetPassword');
  const FORGOT_ROUTE = routeUtils.getConfigRoute('Account', 'ForgotPassword');

  return (
    <Route path={ROUTE.path} component={AccountRoot.Container}>
      <IndexRoute component={Login} />
      <Route name={ACTIVATION_ROUTE.name} path={ACTIVATION_ROUTE.path} component={Activation} />
      <Route name={LOGIN_ROUTE.name} path={LOGIN_ROUTE.path} component={Login} />
      <Route name={RESET_ROUTE.name} path={RESET_ROUTE.path} component={ResetPasswordWrapper} />
      <Route name={FORGOT_ROUTE.name} path={FORGOT_ROUTE.path} component={ForgotPasswordWrapper} />
    </Route>
  );
};

export default AccountRoutes;



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.AccountRoutes.js